import { AccredibleIconComponentModule } from '@accredible-frontend-v2/new-components/icon';
import { AccredibleTooltipModule } from '@accredible-frontend-v2/new-components/tooltip';
import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { AccredibleTextInputComponent } from './text-input.component';

@NgModule({
  declarations: [AccredibleTextInputComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    A11yModule,
    ReactiveFormsModule,
    AccredibleIconComponentModule,
    AccredibleTooltipModule,
  ],
  exports: [AccredibleTextInputComponent],
})
export class AccredibleTextInputModule {}
